import gql from 'graphql-tag';

export default gql`
    query($organizationId: String!, $url: String!) {
        checkPreCheckoutURL(organizationId: $organizationId, url: $url)
    }
`;
